import {AuthFormLayout, AuthFormLayoutWider} from '../../ui/layouts/auth';
import {Headline1, Body1} from '../../ui/atoms/typography';
import {VerticalSpacer} from '../../ui/atoms/spacer';
import {ResponsiveWorkspaceLogo, NotificationWrapper} from './sign-in.styles';
import {ComponentType} from 'react';
import {MobileWrapper} from '../../ui/molecules/workspace/logo-toggle/logo-toggle';
import {DesktopWrapper} from '../dashboard/company-legacy/company-components/company-checkins/company-checkins.style';
import {Image} from '../../ui/atoms/image';
import {Link} from '../../ui/atoms/link';
import {NotificationCard} from '@ui/molecules/notification/notification';
import Navbar from '@ui/molecules/onboarding-nav';
import {FlexWrapper} from '../admin/admin-profile/admin-profile.styles';
import {BeamLogoWithName} from '../../ui/atoms/icons/beam-logo-name';
import {cloudinary} from '../../assets/images/cloudinary';
import {ResponsiveBody1} from './sign-in.styles';
const {signIn: img} = cloudinary;

const image = {
  src: img,
  extension: 'png',
  variants: [{src: img, size: '1x'}],
};

export const AdminSignInPage = ({
  FormComponent,
}: {
  FormComponent: ComponentType;
}) => {
  return (
    <AuthFormLayoutWider>
      <DesktopWrapper>
        <Navbar>
          <FlexWrapper style={{height: '40px'}}>
            <div>
              <BeamLogoWithName />
            </div>
            <ResponsiveBody1 kind="textDark" style={{fontSize: '14px'}}>
              Don’t have an account? <Link to="/sign-up">Sign up</Link>
            </ResponsiveBody1>
          </FlexWrapper>
        </Navbar>
        <div
          style={{
            width: '100%',
            background: '#ededf2',
            height: '1px',
          }}></div>
      </DesktopWrapper>
      <MobileWrapper>
        <NotificationWrapper>
          <NotificationCard />
        </NotificationWrapper>
      </MobileWrapper>
      <AuthFormLayout
        margin="30px auto"
        marginTop="50px"
        maxWidthDefault="600px">
        <MobileWrapper className="mx-5">
          <ResponsiveWorkspaceLogo>
            <BeamLogoWithName />
          </ResponsiveWorkspaceLogo>
          <VerticalSpacer size="40px" />
        </MobileWrapper>
        <Headline1 align="center">Sign in</Headline1>
        <VerticalSpacer size="10px" />
        <Body1 kind="textBody" align="center">
          Kindly fill in your details to login
        </Body1>
        <VerticalSpacer size="20px" />
        <FormComponent />
        <DesktopWrapper>
          <Image alt="grouping" {...image} width="100%" />
        </DesktopWrapper>
        <MobileWrapper>
          <VerticalSpacer size="20px" />

          <ResponsiveBody1
            kind="textDark"
            style={{fontSize: '14px'}}
            align="center">
            Don’t have an account? <Link to="/sign-up">Sign up</Link>
          </ResponsiveBody1>
        </MobileWrapper>
      </AuthFormLayout>
    </AuthFormLayoutWider>
  );
};
